<template>
    <div>
        <v-row no-gutters class="primary--text">
            <v-col cols="12">
                <div class="body-2 pa-0 font-weight-bold">
                    {{nombre}}
<!--                    <v-tooltip bottom max-width="200px">-->
<!--                        <template v-slot:activator="{ on }">-->
<!--                            <v-icon small v-on="on">mdi-information-outline</v-icon>-->
<!--                        </template>-->
<!--                        <span>{{descripcion}}</span>-->
<!--                    </v-tooltip>-->
                </div>
                <div class="caption">{{descripcion}}</div>
            </v-col>
        </v-row>
        <v-row no-gutters class="primary--text">
            <v-col cols="12">
                <slot name="seleccion">
                </slot>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    export default {
        name: "EscenarioOpcionComponente",
        props: {
            nombre: {type: String, required: true},
            descripcion: {type: String, required: true},
        }
    }
</script>

<style scoped>

</style>